"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when attempting to perform an operation that the current user is not
 * authorized
 * @param {string} - The reson for being denied
 */
class UnauthorizedError extends ExtendableError_1.default {
    constructor(reason) {
        super(`Unauthorized: ${reason}`);
        this.reason = reason;
        this.reason = reason;
    }
}
exports.default = UnauthorizedError;
